import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const ProjectCostsView = (props) => {
    const classes = props.classes;
    
    const workType1Error = props.validationErrors.workType1.show;
    const workType1HelperText = props.validationErrors.workType1.show ? props.validationErrors.workType1.errorMessage : '';
    const workType2Error = props.validationErrors.workType2.show;
    const workType2HelperText = props.validationErrors.workType2.show ? props.validationErrors.workType2.errorMessage : '';
    const workType3Error = props.validationErrors.workType3.show;
    const workType3HelperText = props.validationErrors.workType3.show ? props.validationErrors.workType3.errorMessage : '';
    
    const service1Error = props.validationErrors.service1.show;
    const service1HelperText = props.validationErrors.service1.show ? props.validationErrors.service1.errorMessage : '';
    const service2Error = props.validationErrors.service2.show;
    const service2HelperText = props.validationErrors.service2.show ? props.validationErrors.service2.errorMessage : '';
    const service3Error = props.validationErrors.service3.show;
    const service3HelperText = props.validationErrors.service3.show ? props.validationErrors.service3.errorMessage : '';
    
    const supplier1Error = props.validationErrors.supplier1.show;
    const supplier1HelperText = props.validationErrors.supplier1.show ? props.validationErrors.supplier1.errorMessage : '';
    const supplier2Error = props.validationErrors.supplier2.show;
    const supplier2HelperText = props.validationErrors.supplier2.show ? props.validationErrors.supplier2.errorMessage : '';
    const supplier3Error = props.validationErrors.supplier3.show;
    const supplier3HelperText = props.validationErrors.supplier3.show ? props.validationErrors.supplier3.errorMessage : '';
    
    const cost1Error = props.validationErrors.cost1.show;
    const cost1HelperText = props.validationErrors.cost1.show ? props.validationErrors.cost1.errorMessage : '';
    const cost2Error = props.validationErrors.cost2.show;
    const cost2HelperText = props.validationErrors.cost2.show ? props.validationErrors.cost2.errorMessage : '';
    const cost3Error = props.validationErrors.cost3.show;
    const cost3HelperText = props.validationErrors.cost3.show ? props.validationErrors.cost3.errorMessage : '';

    const expectedCostsError = props.validationErrors.expectedCosts.show;
    const expectedCostsHelperText = props.validationErrors.expectedCosts.show ? props.validationErrors.expectedCosts.errorMessage : '';
    const amountRequestedError = props.validationErrors.amountRequested.show;
    const amountRequestedHelperText = props.validationErrors.amountRequested.show ? props.validationErrors.amountRequested.errorMessage : '';
    
    const now = new Date();
    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <form name="trading-online-voucher-scheme-2020">    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="projectElements">
                                PROJECT COSTS
                            </h3>
                        </CardHeader>
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="expenditure">
                                Trading Online Supplier Expenditure&nbsp;
                                {props.validationErrors.amountRequested.check === null ? ' ' : (props.validationErrors.amountRequested.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>This is where things get real. This is where you enter the real quotes from your <b>chosen</b> supplier(s). You may have one or more suppliers chosen, and for each chosen supplier you are expected to have gotten two other quotes, for a total of 3 quotes per work item .</p>
                                                    <p>You will send the quotes from the suppliers you rejected separately; in this section you only include the supplier quotes that you accepted.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="supplier1">
                                Supplier 1
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier1Name'
                                        labelText='Supplier'
                                        helperText={supplier1HelperText}
                                        error={supplier1Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Sionnach Buí Ltd.',
                                            name: 'supplier1Name',
                                            value: props.supplier1,
                                            onChange: props.handleSupplier1,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier1WorkType'
                                        labelText='Product / Service'
                                        helperText={workType1HelperText}
                                        error={workType1Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Develop eCommerce Platform',
                                            name: 'supplier1WorkType',
                                            value: props.workType1,
                                            onChange: props.handleWorkType1,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier1Service'
                                        labelText='Service Provider'
                                        helperText={service1HelperText}
                                        error={service1Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Google Cloud, Stripe',
                                            name: 'supplier1Service',
                                            value: props.service1,
                                            onChange: props.handleService1,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier1Cost'
                                        labelText='Cost (Ex. VAT)'
                                        helperText={cost1HelperText}
                                        error={cost1Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '1500',
                                            name: 'supplier1Cost',
                                            value: props.cost1,
                                            onChange: props.handleCost1,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="supplier2">
                                Supplier 2
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier2Name'
                                        labelText='Supplier'
                                        helperText={supplier2HelperText}
                                        error={supplier2Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Peter O Toole',
                                            name: 'supplier2Name',
                                            value: props.supplier2,
                                            onChange: props.handleSupplier2,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier2WorkType'
                                        labelText='Product / Service'
                                        helperText={workType2HelperText}
                                        error={workType2Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Product Photography',
                                            name: 'supplier2WorkType',
                                            value: props.workType2,
                                            onChange: props.handleWorkType2,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier2Service'
                                        labelText='Service Provider'
                                        helperText={service2HelperText}
                                        error={service2Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Pro Photo',
                                            name: 'supplier2Service',
                                            value: props.service2,
                                            onChange: props.handleService2,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier2Cost'
                                        labelText='Cost (Ex. VAT)'
                                        helperText={cost2HelperText}
                                        error={cost2Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '1000',
                                            name: 'supplier2Cost',
                                            value: props.cost2,
                                            onChange: props.handleCost2,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="supplier3">
                                Supplier 3
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier3Name'
                                        labelText='Supplier'
                                        helperText={supplier3HelperText}
                                        error={supplier3Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Google',
                                            name: 'supplier3Name',
                                            value: props.supplier3,
                                            onChange: props.handleSupplier3,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier3WorkType'
                                        labelText='Product / Service'
                                        helperText={workType3HelperText}
                                        error={workType3Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Marketing Campaign',
                                            name: 'supplier3WorkType',
                                            value: props.workType3,
                                            onChange: props.handleWorkType3,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier3Service'
                                        labelText='Service Provider'
                                        helperText={service3HelperText}
                                        error={service3Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: 'Google Ads',
                                            name: 'supplier3Service',
                                            value: props.service3,
                                            onChange: props.handleService3,
                                            autoComplete: 'off'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3}>
                                    <CustomInput
                                        id='supplier3Cost'
                                        labelText='Cost (Ex. VAT)'
                                        helperText={cost3HelperText}
                                        error={cost3Error}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '277',
                                            name: 'supplier3Cost',
                                            value: props.cost3,
                                            onChange: props.handleCost3,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h5 className={classes.title} id="requestAmount">
                                Trading Online Voucher Requested Amount (Ex. VAT)
                            </h5>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={6} lg={4}>
                                    <CustomInput
                                        id='expectedCosts'
                                        labelText='Expected Costs'
                                        helperText={expectedCostsHelperText}
                                        error={expectedCostsError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '2777',
                                            name: 'expectedCosts',
                                            value: props.expectedCosts,
                                            onChange: props.handleExpectedCosts,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={4}>
                                    <CustomInput
                                        id='amountRequested'
                                        labelText='Amount Requested'
                                        helperText={amountRequestedHelperText}
                                        error={amountRequestedError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            placeholder: '2500',
                                            name: 'amountRequested',
                                            value: props.amountRequested,
                                            onChange: props.handleAmountRequested,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            ),
                                            type: 'number'
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_ELEMENTS}>
                                    &lt; Project Elements 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_GRANT}>
                                    Grant History &gt;
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

ProjectCostsView.propTypes = { 
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    validationErrors: PropTypes.object.isRequired,
    handleCost1: PropTypes.func.isRequired,
    handleCost2: PropTypes.func.isRequired,
    handleCost3: PropTypes.func.isRequired,
    handleWorkType1: PropTypes.func.isRequired,
    handleWorkType2: PropTypes.func.isRequired,
    handleWorkType3: PropTypes.func.isRequired,
    handleService1: PropTypes.func.isRequired,
    handleService2: PropTypes.func.isRequired,
    handleService3: PropTypes.func.isRequired,
    handleSupplier1: PropTypes.func.isRequired,
    handleSupplier2: PropTypes.func.isRequired,
    handleSupplier3: PropTypes.func.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(ProjectCostsView));